/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { orgBudget, orgBudgetAssignedCostCenters } from './budget.i18n';
import {
  orgCostCenter,
  orgCostCenterAssignedBudgets,
  orgCostCenterBudgets,
} from './cost-center.i18n';
import { orgPurchaseLimit } from './permission.i18n';
import {
  orgUnit,
  orgUnitApprovers,
  orgUnitAddress,
  orgUnitAssignedApprovers,
  orgUnitAssignedRoles,
  orgUnitAssignedUsers,
  orgUnitChildren,
  orgUnitCostCenters,
  orgUnitUserRoles,
  orgUnitUsers,
} from './units.i18n';
import {
  orgUserGroup,
  orgUserGroupAssignedPermissions,
  orgUserGroupAssignedUsers,
  orgUserGroupPermissions,
  orgUserGroupUsers,
} from './user-group.i18n';
import {
  orgUser,
  orgUserApprovers,
  orgUserAssignedApprovers,
  orgUserAssignedPermissions,
  orgUserAssignedUserGroups,
  orgUserPermissions,
  orgUserUserGroups,
} from './user.i18n';

/**
 * The organization i18n labels provide generic labels for all organization sub features.
 * Once #7154 is in place, we can start adding specific i18n labels. The organization labels
 * will then serve as a backup.
 */

export const organization = {
  organization: {
    enabled: 'Activo',
    disabled: 'Deshabilitado',

    enable: 'Habilitar',
    disable: 'Inutilizar',

    name: 'Nombre',
    code: 'Código',

    hecho: 'hecho',

    cancel: 'Cancelar',

    add: 'Agregar',
    manageUsers: 'Administrar usuarios',
    create: 'Crear {{name}}',
    edit: 'Editar',
    save: 'Guardar {{name}}',
    delete: 'Borrar',

    assign: 'Gestionar',

    active: 'Activo',
    status: 'Estado',
    details: 'Detalles',

    messages: {
      emptyList: 'La lista está vacía',
    },
    userRoles: {
      b2bcustomergroup: 'Cliente',
      b2bapprovergroup: 'Aprobador',
      b2bmanagergroup: 'Gerente',
      b2badmingroup: 'Admin',
    },

    userRights: {
      unitorderviewergroup: 'Ver pedidos a nivel de unidad',
    },

    breadcrumb: 'Organización',

    notification: {
      noSufficientPermissions: 'No hay permisos suficientes para acceder a esta página',
      notExist: 'Este artículo no existe',
      disabled: 'No se puede editar un elemento deshabilitado',
    },

    confirmation: {
      cancel: 'CANCELAR',
      confirm: 'CONFIRMAR',
      disable: 'INUTILIZAR',
      delete: 'BORRAR',
    },

    httpHandlers: {
      conflict: {
        budget: 'El presupuesto con el código {{ code }} ya existe.',
        costCenter: 'El centro de coste con el código {{ code }} ya existe.',
        unit: 'La unidad organizativa con uid {{ code }} ya existe.',
        user: 'El usuario con correo electrónico {{ code }} ya existe',
        userGroup: 'El grupo de usuarios con id {{ code }} ya existe',
        permission: 'El permiso de aprobación con el código {{ code }} ya existe.',
        unknown: 'Error de validación del servidor.',
      },
    },
    information: 'Información',
  },

  // sub feature labels are added below
  orgCostCenter,
  orgCostCenterBudgets,
  orgCostCenterAssignedBudgets,
  orgBudget,
  orgBudgetAssignedCostCenters,
  orgUnit,
  orgUnitChildren,
  orgUnitApprovers,
  orgUnitAssignedApprovers,
  orgUnitAssignedRoles,
  orgUnitUsers,
  orgUnitUserRoles,
  orgUnitAssignedUsers,
  orgUnitCostCenters,
  orgUnitAddress,

  orgUserGroup,
  orgUserGroupUsers,
  orgUserGroupAssignedUsers,
  orgUserGroupPermissions,
  orgUserGroupAssignedPermissions,
  orgUser,
  orgUserUserGroups,
  orgUserAssignedUserGroups,
  orgUserApprovers,
  orgUserAssignedApprovers,
  orgUserPermissions,
  orgUserAssignedPermissions,
  orgPurchaseLimit,
};
